module.exports = "//d274d294w9cx2v.cloudfront.net/d53acda9e9ee7a7ff837b89865371b277f90037b/images/photo-couple.png";